import styled from 'styled-components';
import { GlobalColors, GlobalFonts } from '../../globals';

export const ContCasosUsoSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 80px 0px;
  background: linear-gradient(
    260deg,
    ${GlobalColors.colorPrimary} 0%,
    ${GlobalColors.colorPrimaryDark} 100%
  );

  @media (min-width: 300px) and (max-width: 767px) {
    padding: 60px 0;
  }
`;

export const TitleCasosUso = styled.h2`
  font-family: ${GlobalFonts.fontBold};
  font-size: 40px;
  line-height: 48px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 20px;
  width: 100%;
  max-width: 800px;
  @media (min-width: 300px) and (max-width: 767px) {
    font-size: 32px;
    line-height: 40px;
    width: 100%;
  }
`;

export const DescCasosUso = styled.p`
  font-family: ${GlobalFonts.fontRegular};
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 50px;
  width: 70%;

  @media (min-width: 300px) and (max-width: 767px) {
    font-size: 16px;
    line-height: 24px;
    width: 90%;
    margin-bottom: 30px;
  }
`;

export const SubtitleCasosUso = styled.h3`
  font-family: ${GlobalFonts.fontBold};
  font-size: 32px;
  line-height: 32px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 40px;
  width: 80%;

  @media (min-width: 300px) and (max-width: 767px) {
    font-size: 20px;
    line-height: 28px;
    width: 90%;
    margin-bottom: 30px;
  }
`;

export const CasosUsoGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 120px;
  width: 100%;
  margin-bottom: 20px;
  justify-content: center;
  justify-items: center;
  max-width: 1440px;

  @media (min-width: 300px) and (max-width: 767px) {
    gap: 40px;
  }
`;

export const CasoUsoCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  min-height: 180px;
  max-width: 331px;
  width: 100%;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 16px;
    padding: 8px;
    background: linear-gradient(
      135deg,
      #fa6c40 0%,
      #e66079 25%,
      #da59a1 50%,
      #c74dd7 100%
    );
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }

  &:hover::before {
    opacity: 1;
  }

  @media (min-width: 300px) and (max-width: 767px) {
    max-width: 331px;
    width: 80%;
  }
`;

export const CasoUsoContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.showDescription ? 0 : 1)};

  @media (min-width: 300px) and (max-width: 767px) {
    opacity: 1;
  }
`;

export const CasoUsoIcon = styled.div`
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (min-width: 300px) and (max-width: 767px) {
    width: 50px;
    height: 50px;
    margin-bottom: 15px;
  }
`;

export const CasoUsoTitle = styled.h3`
  font-family: ${GlobalFonts.fontBold};
  font-size: 32px;
  line-height: 40px;
  margin: 0;

  background: linear-gradient(
    135deg,
    #fa6c40 0%,
    #e66079 25%,
    #da59a1 50%,
    #c74dd7 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (min-width: 300px) and (max-width: 767px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const CasoUsoDescription = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  background: transparent;
  border-radius: 16px;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.showDescription ? 1 : 0)};
  transform: ${(props) =>
    props.showDescription ? 'translateY(0)' : 'translateY(20px)'};
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: ${(props) => (props.showDescription ? 'auto' : 'none')};
  z-index: 1;

  @media (min-width: 300px) and (max-width: 767px) {
    position: relative;
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
    padding: 10px 0 0 0; /* reduced top padding to lift description */
    background: transparent;
  }
`;

export const DescriptionTitle = styled.h4`
  font-family: ${GlobalFonts.fontBold};
  font-size: 32px;
  line-height: 28px;
  margin-bottom: 15px;
  text-align: center;

  background: linear-gradient(
    135deg,
    #fa6c40 0%,
    #e66079 25%,
    #da59a1 50%,
    #c74dd7 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (min-width: 300px) and (max-width: 767px) {
    display: none; /* hide duplicate title on mobile */
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 10px;
  }
`;

export const DescriptionText = styled.p`
  font-family: ${GlobalFonts.fontRegular};
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: ${GlobalColors.colorText};
  margin: 0;
  text-align: center;

  @media (min-width: 300px) and (max-width: 767px) {
    font-size: 13px;
    line-height: 19px;
    margin-top: -6px; /* pull up the text a bit under the main title */
  }
`;
